import axios from 'axios';

var timer;
var isRunning = false;
const AuthBtn1 = document.querySelector('#auth');
const AuthBtn2 = document.querySelector('#nchk');

const formCheck = ($form) => {
    const $input = $form.find('input, select').toArray();
    let aaa = 1;

    if ($form) {
        $($input).each((i,v) => {
            if(v.value === '' && $(v).data('optional') != false) {
                alert($(v).data('check'));
                $(v).focus();
                aaa = 99;
                return false;
            }
        });
    } 

    return aaa;
}

const sendAuthNum = () => {
    var leftSec = 180,
    display = document.querySelector('#timer');

    if (isRunning){
        clearInterval(timer);
    }
    startTimer(leftSec, display);
}

const startTimer = (count, display) => {
    var minutes, seconds;
    timer = setInterval(function () {
        minutes = parseInt(count / 60, 10);
        seconds = parseInt(count % 60, 10);
        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        display.placeholder = minutes + ":" + seconds;

        if (--count < 0) {
            clearInterval(timer);
            isRunning = false;
            document.getElementById('timer').disabled = true;
            alert('입력시간이 초과되었습니다.\n\n재인증 해주세요.');
        }
    }, 1000);
    isRunning = true;
}

async function sendSMS() {
    const $form = $('#userck');
    const ipts = document.querySelector('#userck');
    const aa = formCheck($form);
    
    if(aa < 99) {
        try {
            await axios
                .post('/auth/store', ipts)
                .then(function (res) {
                    if(res.status === 200) {
                        if(res.data.res === 200) {
                            document.getElementById('token').value = res.data.token;
                            document.getElementById('secret').classList.add('on');
                            document.getElementById('timer').disabled = false;
                            document.getElementById('timer').value = '';
                            document.getElementById('token').value = res.data.token;                      
                            sendAuthNum();
                            AuthBtn1.innerHTML = '재인증';
                        } else {
                            alert(res.data.message)
                        }
                    } else {
                        alert("인증시 오류가 발생되었습니다. 고객센터에 문의해주세요.\n1666-1243");
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        } catch (error) {
            alert("인증시도가 실패했습니다.3");
        }
    }   
}

async function chkeckSMS() {
    try {
        await axios
            .post('/auth/mobile', {
                token:      document.getElementById('token').value,
                number:     document.getElementById('timer').value,
                property:   document.getElementById('property').value
            })
            .then(function (res) {
                if(res.status === 200) {
                    if(res.data.res === 200) {
                        document.getElementById('no').value = res.data.id;
                        document.getElementById('userck').action = res.data.url;
                        document.getElementById('userck').submit();
                    } else {                        
                        alert(res.data.message)
                    }
                } else {
                    alert("인증시 오류가 발생되었습니다. 고객센터에 문의해주세요.\n1666-1243");
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    } catch (error) {
        alert("인증시도가 실패했습니다.3");
    }  
}

if (AuthBtn1) {
    AuthBtn1.addEventListener("click", sendSMS);
}

if (AuthBtn2) {
    AuthBtn2.addEventListener("click", chkeckSMS);
}

$(document).on("keyup", ".len", (e) => {
    let len = $(e.currentTarget).data('length')
    let legex  = new RegExp(`(^[0-9]{1,${len}}).*`)
    $(e.currentTarget).val($(e.currentTarget).val().replace(legex, '$1'))
}) 

$(document).on("keyup", ".phone", (e) => {
    let prev    = $(e.currentTarget).val();
    let str     = prev.replace(/[^0-9]/g, "").replace(/(^02|^0505|^01.{1}|^0[0-9]{2})([0-9]+)?([0-9]{4})/,"$1-$2-$3").replace("--", "-");
    $(e.currentTarget).val(str);
});

$(document).ready(function() {
    $('.form-wrapper .it-wrap .it').click((e) => {
        $('.form-wrapper .it-wrap .it').removeClass('active')
        $(e.currentTarget).addClass('active')
        $('.form-wrapper input[name=type]').val($(e.currentTarget).data('type'))
        let i = $(e.currentTarget).index()
        if(i === 0){
            $('.cor').hide()
            $('.per').show()
            $('.per input').each((i,v) => {
                $(v).data('optional', true)
            })
            $('.cor input').each((i,v) => {
                $(v).data('optional', false)
            })
        }
        else{
            $('.per').hide()
            $('.cor').show()
            $('.cor input').each((i,v) => {
                $(v).data('optional', true)
            })
            $('.per input').each((i,v) => {
                $(v).data('optional', false)
            })
        }
    })

    /* main tab css */
    if($('.member-wrapper').length){
        var tab_1 = $("#1").offset().top;
        // var tab_2 = $("#2").offset().top - 10;
        // var tab_3 = $("#3").offset().top - 10;
        var tab_4 = $("#4").offset().top - 10;
    }
    $(window).scroll(function(){  
        if($(window).scrollTop() < tab_1){  
            $('.top-tab').removeClass('on');  
            // 탑버튼
            $('.top-btn').removeClass('on');  
        }else if($(window).scrollTop() > tab_1 && $(window).scrollTop() < tab_4){  
            $('.top-tab').addClass('on');  
            $('.top-tab a').removeClass('tab');  
            $('.top-tab a').eq(0).addClass('tab');  
            // 탑버튼
            $('.top-btn').addClass('on');  
        }else{  
            $('.top-tab').addClass('on');  
            $('.top-tab a').removeClass('tab');  
            $('.top-tab a').eq(1).addClass('tab');  
        }

        var scrollTop = $(this).scrollTop();
        var innerHeight = $(window).height();
        var scrollHeight = $(document).height();
        if (scrollTop + innerHeight >= scrollHeight) {
            $('.btns-amenity').addClass('active');
        } else {
            $('.btns-amenity').removeClass('active');
        }
    });  

    $('.btns-amenity').click(function () {
        $(this).toggleClass('active');
    });
    $('.bg-img img').click(function () {
        $('.btns-amenity').removeClass('active');
    })
});